import chroma from 'chroma-js';
import { getIsLightColor } from './coreColorUtil';

const DEFAULT_LIGHT_LUMINANCE_THRESHOLD = 0.6;

/**
 * Based on the input color, returns a contrasting colour.
 * If the input color is light, it returns a darker color for dark mode and keeps the original for light mode.
 * If the input color is dark, it returns a lighter color for light mode and keeps the original for dark mode.
 */
export const getLightDarkComboColors = (
    colorHex: string,
    lightLuminanceThreshold = DEFAULT_LIGHT_LUMINANCE_THRESHOLD,
): { lightColor: string; darkColor: string; whiteTextOnDarkAllowed: boolean } => {
    const chromaColor = chroma(colorHex);
    const isLightColor = chromaColor.luminance() > lightLuminanceThreshold;

    if (isLightColor) {
        return {
            lightColor: colorHex,
            darkColor: chromaColor.luminance(0.18, 'hsl').hex(),
            whiteTextOnDarkAllowed: true,
        };
    }

    return {
        lightColor: chromaColor.luminance(0.85, 'hsl').hex(),
        darkColor: colorHex,
        whiteTextOnDarkAllowed: !getIsLightColor(colorHex),
    };
};
